/**
 * Sanitize payload before sending to the API.
 * - Convert empty strings to null for UUID fields (ending in 'Id')
 * - Convert empty strings to null for known numeric fields
 * Prevents SQL Server conversion errors.
 */

const NUMERIC_FIELDS = new Set([
  'Price', 'CompareAtPrice', 'CostPrice', 'Weight', 'SortOrder',
  'PriceAdjustment', 'QuantityOnHand', 'ReorderLevel', 'Quantity',
  'Total', 'Subtotal', 'Tax', 'ShippingCost', 'Discount',
  'MinOrderAmount', 'MaxOrderAmount',
  'DiscountPercent', 'MaxDiscountAmount', 'UsageLimit', 'UsageCount',
  'PerCustomerLimit', 'DiscountAmount',
]);

export function sanitizePayload(obj) {
  if (!obj || typeof obj !== 'object') return obj;
  const result = { ...obj };
  for (const key of Object.keys(result)) {
    const val = result[key];
    // UUID fields: empty string → null
    if (typeof val === 'string' && val.trim() === '' && /Id$/.test(key)) {
      result[key] = null;
    }
    // Known numeric fields: empty string → null, string numbers → number
    else if (NUMERIC_FIELDS.has(key)) {
      if (val === '' || val === null || val === undefined) {
        result[key] = null;
      } else if (typeof val === 'string') {
        const num = Number(val);
        result[key] = isNaN(num) ? null : num;
      }
    }
  }
  return result;
}
